// src/components/Payment/addbanner.js
import React from 'react';

const Refundhotel = () => {
  return (
    <div>
      <h2>Refund hotel</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Refundhotel;
